import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialNavigationLeftCircle1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 9.14h-1.53V6.09h-1.52V4.57H25.9V3.05h-3.04V1.52h-3.05V0h-7.62v1.52H9.14v1.53H6.09v1.52H4.57v1.52H3.05v3.05H1.52v3.05H0v7.62h1.52v3.05h1.53v3.04h1.52v1.53h1.52v1.52h3.05v1.53h3.05V32h7.62v-1.52h3.05v-1.53h3.04v-1.52h1.53V25.9h1.52v-3.04h1.53v-3.05H32v-7.62h-1.52ZM25.9 21.33h-1.52v1.53h-1.52v1.52h-4.57v-1.52h1.52v-1.53h1.52v-1.52h-1.52v-1.52h-6.1v3.04h-1.52v-1.52h-1.52v-1.52H9.14v-1.53H7.62v-1.52H6.09v-1.53h1.53v-1.52h1.52v-1.52h1.53V9.14h1.52V7.62h1.52v3.05h9.15v1.52h1.52v1.52h1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialNavigationLeftCircle1
